module.exports = __webpack_public_path__ + "img/DE01475.6eebeb87.png";